import React from 'react';
import styles from './PaymentOptions.module.scss';
import LazyImage from 'gui/components/LazyImage/LazyImage';

interface IPaymentOptionsProps {
  className?: string;
}

const PaymentOptions = (props: IPaymentOptionsProps) => {
  return (
    <div className={`${styles.paymentOptions} ${props.className}`.trim()}>
      <LazyImage src={'/img/guranteeBit.png'} title={'Bit'}/>
      <LazyImage src={'/img/guranteeVisa.png'} title={'Visa'}/>
      <LazyImage src={'/img/guranteeMastercard.png'} title={'Mastercard'}/>
    </div>
  );
};

PaymentOptions.defaultProps = {
  className: '',
};

export default React.memo(PaymentOptions);
